/* eslint-disable no-mixed-operators */
import * as React from 'react';
import Color from '../../../core/libraries/Color';
import Template from '../../../core/libraries/Template';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import Constants from '../../../core/libraries/Constants';
import { connect } from 'react-redux';
import _ from 'lodash';
import RbLabel, { LabelSize } from '../../../bosch-react/components/label/RbLabel';
import RbTextField from '../../../bosch-react/components/text-field/RbTextField';
import RbRadio from '../../../bosch-react/components/radio/RbRadio';
import { confirmDialog } from '../../Dialog/actions';
import CustomizedPeoplePicker from '../../../core/components/PeoplePicker/CustomizedPeoplePicker';
import { PrincipalType } from '../../../core/components/PeoplePicker/types';
import { ILowerFirstCaseMetadata } from '../../AccessMediator/types';
import { IPersona, IPersonaProps } from '@fluentui/react';
import { removeAliasDomain } from '../../../utils/converter';

interface MoveReport_AdditionalInformationProps {
    confirmDialog: typeof confirmDialog,
    moveItem: ILowerFirstCaseMetadata | null,
    updateMoveItem: any,
    srcItem: ILowerFirstCaseMetadata | null,
}

interface IState {
    // RnD
    abstract: string,
    documentType: any,
    rFTL: boolean,
    securityClass: string,
    documentNumber: string,
    projectNumber: string,
    authorizedAssociates: string[],
    organizationalUnits: string[],
    // LL
    product: string,
    process: string,
    plantBU: string,
    iqisNumber: string,
    validationMessage: any,
}

class MoveReport_AdditionalInformation extends React.Component<MoveReport_AdditionalInformationProps, IState> {

    rFTLRef: React.RefObject<any> = React.createRef();
    authPeopleRef: React.RefObject<any> = React.createRef();
    authGroupRef: React.RefObject<any> = React.createRef();

    constructor(props: MoveReport_AdditionalInformationProps) {
        super(props);

        this.state = {
            // RnD
            abstract: "",
            documentType: null,
            rFTL: false,
            securityClass: "",
            documentNumber: "",
            projectNumber: "",
            // LL
            product: "",
            process: "",
            plantBU: "",
            iqisNumber: "",
            validationMessage: {},
            authorizedAssociates: [],
            organizationalUnits: [],
        };
        // RnD Properties
        this.renderAbstract = this.renderAbstract.bind(this);
        this.renderDocumentType = this.renderDocumentType.bind(this);
        this.renderRFTL = this.renderRFTL.bind(this);
        this.renderSecurityClass = this.renderSecurityClass.bind(this);
        this.renderDocumentNumber = this.renderDocumentNumber.bind(this);
        this.renderProjectNumber = this.renderProjectNumber.bind(this);
        this.renderCustomACL = this.renderCustomACL.bind(this);
        // LL Properties
        this.renderProduct = this.renderProduct.bind(this);
        this.renderProcess = this.renderProcess.bind(this);
        this.renderPlantBU = this.renderPlantBU.bind(this);
        this.renderIQISNumber = this.renderIQISNumber.bind(this);
    }

    render() {
        let element: any = "";
        let { moveItem, srcItem } = this.props
        if (moveItem?.uploadType !== srcItem?.uploadType) { // Else the upload type must not be empty to be shown
            element = (
                <div className="ms-Grid">

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                            <RbLabel style={{ color: Color.BLUE }}><h4 style={{ marginBottom: "0px" }}>Additional Information</h4></RbLabel>
                        </div>
                    </div>
                    {/* RnD Properties */}
                    {
                        moveItem?.uploadType === Constants.UPLOAD_TYPE.RnD && <>
                            {this.renderAbstract()}
                            {this.renderDocumentType()}
                            {this.renderRFTL()}
                            {this.renderSecurityClass()}
                            {this.renderDocumentNumber()}
                            {this.renderProjectNumber()}
                            {this.renderCustomACL()}
                        </>
                    }
                    {/* LL Properties */}
                    {
                        moveItem?.uploadType === Constants.UPLOAD_TYPE.LL && <>
                            {this.renderProduct()}
                            {this.renderProcess()}
                            {this.renderPlantBU()}
                            {this.renderIQISNumber()}
                        </>
                    }
                    {

                    }
                </div>
            );
        }
        else {
            element = moveItem?.uploadType === Constants.UPLOAD_TYPE.RnD ? <div className="ms-Grid">

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <RbLabel style={{ color: Color.BLUE }}><h4 style={{ marginBottom: "0px" }}>Additional Information</h4></RbLabel>
                    </div>
                </div>
                {this.renderRFTL()}
                {this.renderSecurityClass()}
            </div> : <></>
        }
        return element;
    }

    renderAbstract() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Abstract",
                    <React.Fragment>
                        <RbTextField
                            isMultiple={true} minRows={5} maxRows={8}
                            value={this.state.abstract} onChange={(event) => {
                                this.setState({ abstract: event.currentTarget.value }, () => {
                                    this.props.updateMoveItem("abstract", this.state.abstract)
                                });
                            }}
                        />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.abstract}
                        </RbLabel>
                    </React.Fragment>, false, 4, 8, 12)}
            </div>
        );
    }

    renderDocumentType() {
        let { moveItem } = this.props
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Report type",
                    <React.Fragment>
                        <Dropdown
                            selectedKey={this.state.documentType}
                            placeholder="Choose report type ..."
                            options={Constants.DOCUMENT_TYPE_MASTER_DATA[moveItem!.uploadType!]}
                            onChange={(event, option) => {
                                if (!_.isUndefined(option)) {
                                    this.setState({ documentType: option.key }, () => {
                                        this.props.updateMoveItem("documentType", option.key)
                                    });
                                }
                            }}
                        />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.documentType}
                        </RbLabel>
                    </React.Fragment>, false, 4, 8, 12)}
            </div>
        );
    }

    renderRFTL() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Report contains export controlled material",
                    <RbRadio ref={this.rFTLRef} defaultValue={this.state.rFTL} itemWidth={5} isHorizontal={true} items={[
                        { value: true, label: "Yes" },
                        { value: false, label: "No" }
                    ]}
                        onChange={(selectedValue) => {
                            this.setState({
                                rFTL: !!selectedValue,
                                securityClass: (!!selectedValue) ? Constants.SECURITY_CLASS_SHORT_NAME.SC3 : this.state.securityClass,
                            }, () => {
                                this.props.updateMoveItem('securityClass', this.state.securityClass);
                                this.props.updateMoveItem('relForForeignTradeLegislation', !!selectedValue);

                            });
                        }}
                    />, false, 7, 5, 12)}
            </div>
        );
    }

    renderSecurityClass() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Security class",
                    <React.Fragment>
                        <Dropdown
                            selectedKey={this.state.securityClass}
                            placeholder="Choose security class ..."
                            options={Constants.DD_SECURITY_CLASSES_ALL}
                            disabled={this.state.rFTL}
                            onChange={(event, option) => {
                                !!option && this.setState({
                                    securityClass: option.key.toString()
                                }, () => {
                                    this.props.updateMoveItem("securityClass", this.state.securityClass)
                                });
                            }}
                        />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.securityClass}
                        </RbLabel>
                    </React.Fragment>, false, 4, 8, 12)}
            </div>
        );
    }

    renderDocumentNumber() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Report number",
                    <React.Fragment>
                        <RbTextField value={this.state.documentNumber} onChange={(event) => {
                            this.setState({ documentNumber: event.currentTarget.value }, () => {
                                this.props.updateMoveItem("documentNumber", this.state.documentNumber)
                            });
                        }} />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.documentNumber}
                        </RbLabel>
                    </React.Fragment>, true, 4, 8, 12)}
            </div>
        );
    }

    renderProjectNumber() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Project number",
                    <React.Fragment>
                        <RbTextField value={this.state.projectNumber} onChange={(event) => {
                            this.setState({ projectNumber: event.currentTarget.value },
                                () => {
                                    this.props.updateMoveItem('projectNumber', this.state.projectNumber)
                                }
                            );
                        }} />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.projectNumber}
                        </RbLabel>
                    </React.Fragment>, true, 4, 8, 12)}
            </div>
        );
    }

    onChangeAuthGroup(persona: IPersonaProps[]) {
        let items = !!this.authGroupRef && this.authGroupRef.current.getSelectedItems() || [];
        let results: string[] = [];
        if (items.length > 0) {
            items.forEach((item: any) => {
                !!item.id && results.push(item.id);
            })
            this.setState({
                organizationalUnits: results
            }, () => {
                this.props.updateMoveItem('organizationalUnits', this.state.organizationalUnits)
            })
        }
        this.props.updateMoveItem('preSelectedOrganizationalUnits', persona)
    }

    onChangeAuthPeople(persona: IPersonaProps[]) {
        let items = !!this.authPeopleRef && this.authPeopleRef.current.getSelectedItems() || [];
        let results: string[] = [];
        if (items.length > 0) {
            items.forEach((item: any) => {
                !!item.loginName && results.push(removeAliasDomain(item.loginName));
            })
            this.setState({
                authorizedAssociates: results
            }, () => {
                this.props.updateMoveItem('authorizedAssociates', this.state.authorizedAssociates)
            })
        }
        this.props.updateMoveItem('preSelectedAuthorizedAssociates', persona)
    }

    renderCustomACL() {
        const securityClass = this.props.moveItem?.securityClass
        return (
            !!securityClass && securityClass !== Constants.SECURITY_CLASS_SHORT_NAME.SC1 && <>
                <div className="ms-Grid-row">
                    {Template.renderCommonTemplate(
                        "Authorized Associates",
                        <CustomizedPeoplePicker
                        defaultValue={!!this.props.moveItem?.preSelectedAuthorizedAssociates ? this.props.moveItem?.preSelectedAuthorizedAssociates : []} 
                        principalType={PrincipalType.People} 
                        componentRef={this.authPeopleRef} 
                        onChange={(persona: IPersonaProps[]) => { this.onChangeAuthPeople(persona) }} />
                        , false, 4, 8, 12)}
                </div>
                {securityClass === Constants.SECURITY_CLASS_SHORT_NAME.SC2 &&
                    <div className="ms-Grid-row">
                        {Template.renderCommonTemplate(
                            "Authorized Groups",
                            <CustomizedPeoplePicker 
                            defaultValue={!!this.props.moveItem?.preSelectedOrganizationalUnits ? this.props.moveItem?.preSelectedOrganizationalUnits : []}
                            principalType={PrincipalType.Group} 
                            componentRef={this.authGroupRef} 
                            onChange={(persona: IPersonaProps[]) => { this.onChangeAuthGroup(persona) }} />
                            , false, 4, 8, 12)}
                    </div>}
            </>
        );
    }

    renderProduct() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Product",
                    <React.Fragment>
                        <RbTextField disabled={this.state.process.trim() !== ""}
                            value={this.state.product} onChange={(event) => {
                                this.setState({ product: event.currentTarget.value }, () => {
                                    this.props.updateMoveItem("product", this.state.product)
                                });
                            }} />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.product}
                        </RbLabel>
                    </React.Fragment>
                    , false, 4, 8, 12)}
            </div>
        );
    }

    renderProcess() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Process",
                    <React.Fragment>
                        <RbTextField
                            disabled={this.state.product.trim() !== ""}
                            value={this.state.process} onChange={(event) => {
                                this.setState({ process: event.currentTarget.value }, () => {
                                    this.props.updateMoveItem("process", this.state.process)
                                });
                            }} />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.process}
                        </RbLabel>
                    </React.Fragment>
                    , false, 4, 8, 12)}
            </div>
        );
    }

    renderPlantBU() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "Plant/Business unit",
                    <React.Fragment>
                        <RbTextField value={this.state.plantBU} onChange={(event) => {
                            this.setState({ plantBU: event.currentTarget.value }, () => {
                                this.props.updateMoveItem("plantorBu", this.state.plantBU)
                            });
                        }} />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.plantBU}
                        </RbLabel>
                    </React.Fragment>
                    , false, 4, 8, 12)}
            </div>
        );
    }

    renderIQISNumber() {
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "IQIS number",
                    <React.Fragment>
                        <RbTextField value={this.state.iqisNumber} onChange={(event) => {
                            this.setState({ iqisNumber: event.currentTarget.value }, () => {
                                this.props.updateMoveItem("iqisnumber", this.state.iqisNumber)
                            });
                        }} />
                        <RbLabel className="error-txt" size={LabelSize.Small}>
                            {this.state.validationMessage.iqisNumber}
                        </RbLabel>
                    </React.Fragment>
                    , true, 4, 8, 12)}
            </div>
        );
    }

}

export default connect(null, { confirmDialog }, null, { forwardRef: true })(MoveReport_AdditionalInformation);